var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "site-nav", attrs: { id: "site-nav" } }, [
        _c("div", { staticClass: "w w1200" }, [
          _c("ul", { staticClass: "quick-menu fl" }, [
            _c(
              "li",
              [
                _c(
                  "div",
                  { staticClass: "dt" },
                  [
                    (_vm.userInfo.loginName == null
                    ? true
                    : false)
                      ? _c("router-link", { attrs: { to: "/login" } }, [
                          _vm._v("登录")
                        ])
                      : _vm._e()
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-dropdown",
                  [
                    _c(
                      "span",
                      {
                        staticClass: "el-dropdown-link",
                        staticStyle: { cursor: "pointer", "font-size": "12px" }
                      },
                      [
                        (_vm.userInfo.userName == null
                        ? false
                        : true)
                          ? _c("a", [
                              _vm._v(
                                "您好，" +
                                  _vm._s(
                                    !_vm.nickname ? _vm.userName : _vm.nickname
                                  )
                              )
                            ])
                          : _vm._e()
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-dropdown-menu",
                      { attrs: { slot: "dropdown" }, slot: "dropdown" },
                      [
                        _c("el-dropdown-item", [
                          _c(
                            "a",
                            {
                              attrs: { href: "javaScript:;" },
                              on: { click: _vm.rollOut }
                            },
                            [_vm._v("退出")]
                          )
                        ])
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            (_vm.userInfo.loginName == null
            ? true
            : false)
              ? _c("li", { staticClass: "spacer" })
              : _vm._e(),
            _vm._v(" "),
            _c("li", [
              _c(
                "div",
                { staticClass: "dt" },
                [
                  (_vm.userInfo.loginName == null
                  ? true
                  : false)
                    ? _c("router-link", { attrs: { to: "/register" } }, [
                        _vm._v("注册")
                      ])
                    : _vm._e()
                ],
                1
              )
            ]),
            _vm._v(" "),
            _vm.userType == 1 ? _c("li", { staticClass: "spacer" }) : _vm._e(),
            _vm._v(" "),
            _c("li", [
              _vm.userType == 1
                ? _c(
                    "div",
                    { staticClass: "dt" },
                    [
                      _c(
                        "el-dropdown",
                        { on: { command: _vm.handleCommand } },
                        [
                          _c(
                            "span",
                            {
                              staticClass: "el-dropdown-link",
                              staticStyle: {
                                color: "#D9D9D9",
                                "font-size": "12px",
                                "line-height": "0px"
                              }
                            },
                            [
                              _vm._v("\n                账号认证"),
                              _c("i", {
                                staticClass: "el-icon-arrow-down el-icon--right"
                              })
                            ]
                          ),
                          _vm._v(" "),
                          _vm.isUp == null
                            ? _c(
                                "div",
                                [
                                  _c(
                                    "el-dropdown-menu",
                                    {
                                      attrs: { slot: "dropdown" },
                                      slot: "dropdown"
                                    },
                                    [
                                      _c(
                                        "el-dropdown-item",
                                        { attrs: { command: "企业认证" } },
                                        [_vm._v("企业认证")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "el-dropdown-item",
                                        { attrs: { command: "电工认证" } },
                                        [_vm._v("电工认证")]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _c(
                                "div",
                                [
                                  _c(
                                    "el-dropdown-menu",
                                    {
                                      attrs: { slot: "dropdown" },
                                      slot: "dropdown"
                                    },
                                    [
                                      _vm.isUp.type == 2 && _vm.isUp.status != 3
                                        ? _c(
                                            "el-dropdown-item",
                                            { attrs: { command: "企业认证" } },
                                            [_vm._v("企业认证")]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.isUp.type == 3 && _vm.isUp.status != 3
                                        ? _c(
                                            "el-dropdown-item",
                                            { attrs: { command: "电工认证" } },
                                            [_vm._v("电工认证")]
                                          )
                                        : _vm._e()
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                        ]
                      )
                    ],
                    1
                  )
                : _vm._e()
            ]),
            _vm._v(" "),
            _c(
              "li",
              { staticClass: "li_dorpdown" },
              [
                _c("el-image", {
                  staticStyle: {
                    width: "10px",
                    height: "10px",
                    margin: "0 5px 0 10px"
                  },
                  attrs: {
                    src: _vm.$imageUrl + "/pcImages/images/homeTel.png",
                    fit: "cover"
                  }
                }),
                _vm._v(" " + _vm._s(_vm.informations.consumerHotline))
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("ul", { staticClass: "quick-menu fr" }, [
            _c("li", [
              _c(
                "div",
                { staticClass: "dt" },
                [
                  _c(
                    "router-link",
                    {
                      attrs: {
                        to:
                          _vm.userInfo.loginName == null
                            ? "/login"
                            : "/cashOnDelivery"
                      }
                    },
                    [_vm._v("我的订单")]
                  )
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("li", { staticClass: "spacer" }),
            _vm._v(" "),
            false
              ? _c("li", [
                  _c(
                    "div",
                    { staticClass: "dt" },
                    [
                      _c(
                        "router-link",
                        {
                          attrs: {
                            to:
                              _vm.userInfo.loginName == null
                                ? "/login"
                                : "/cashInquirySheet"
                          }
                        },
                        [_vm._v("我的询价单")]
                      )
                    ],
                    1
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            false ? _c("li", { staticClass: "spacer" }) : _vm._e(),
            _vm._v(" "),
            _c("li", [
              _c(
                "div",
                { staticClass: "dt" },
                [
                  _c(
                    "router-link",
                    {
                      attrs: {
                        to:
                          _vm.userInfo.loginName == null
                            ? "/login"
                            : "/goodsCollection?name=我的收藏"
                      }
                    },
                    [_vm._v("我的收藏")]
                  )
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("li", { staticClass: "spacer" }),
            _vm._v(" "),
            _c("li", [
              _c(
                "div",
                { staticClass: "dt" },
                [
                  _c("router-link", { attrs: { to: _vm.jummpurl } }, [
                    _vm._v(" 商家入驻")
                  ])
                ],
                1
              )
            ]),
            _vm._v(" "),
            _vm.sjzxstatus ? _c("li", { staticClass: "spacer" }) : _vm._e(),
            _vm._v(" "),
            _c("li", [
              _vm.sjzxstatus
                ? _c("div", { staticClass: "dt" }, [
                    _c(
                      "a",
                      { attrs: { href: _vm.$baseUrl, target: "_blank" } },
                      [_vm._v("商家中心")]
                    )
                  ])
                : _vm._e()
            ]),
            _vm._v(" "),
            _c("li", { staticClass: "spacer" }),
            _vm._v(" "),
            _c("li", [
              _c(
                "div",
                { staticClass: "dt" },
                [
                  _c("router-link", { attrs: { to: "/contact" } }, [
                    _vm._v(" 联系我们")
                  ])
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("li", { staticClass: "spacer" }),
            _vm._v(" "),
            _c(
              "li",
              { staticClass: "li_dorpdown" },
              [
                _c("div", { staticClass: "dt" }, [
                  _c(
                    "a",
                    {
                      ref: "appDownloud",
                      staticStyle: { display: "flex", "align-items": "center" },
                      attrs: { href: "javascript:;" },
                      on: {
                        mouseenter: function($event) {
                          _vm.showapp = !_vm.showapp
                        },
                        mouseleave: function($event) {
                          _vm.showapp = !_vm.showapp
                        },
                        click: _vm.goappdown
                      }
                    },
                    [
                      _c("el-image", {
                        staticStyle: {
                          width: "10px",
                          height: "11px",
                          "margin-right": "5px"
                        },
                        attrs: {
                          src: _vm.$imageUrl + "/pcImages/images/homePhone.png",
                          fit: "cover"
                        }
                      }),
                      _vm._v("\n              手机云赢\n            ")
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("transition", { attrs: { name: "el-zoom-in-top" } }, [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.showapp,
                          expression: "showapp"
                        }
                      ],
                      staticClass: "dropdown-menu",
                      staticStyle: {
                        "z-index": "10000000",
                        position: "absolute",
                        background: "rgba(255, 255, 255,1)",
                        width: "250px",
                        height: "auto",
                        color: "rgb(18, 18, 18)"
                      },
                      style: { right: "-" + _vm.downloudPopRight + "px" }
                    },
                    [
                      _c("div", { staticClass: "appdown" }, [
                        _c("div", { staticClass: "weixin" }, [
                          _c("img", {
                            staticClass: "ioscode",
                            attrs: {
                              src: require("../assets/appdownicon/wechatcode1.jpg")
                            }
                          }),
                          _vm._v(" "),
                          _c("div", { staticClass: "iostitle" }, [
                            _c(
                              "div",
                              { staticStyle: { "padding-top": "5px" } },
                              [_vm._v("扫一扫，登录小程序")]
                            ),
                            _vm._v(" "),
                            _c("img", {
                              staticStyle: { width: "25px", height: "25px" },
                              attrs: {
                                src: require("../assets/appdownicon/weixinicon.png")
                              }
                            })
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "iosapp" }, [
                          _c("img", {
                            staticClass: "ioscode",
                            attrs: { src: _vm.iosappcode }
                          }),
                          _vm._v(" "),
                          _c("div", { staticClass: "iostitle" }, [
                            _c(
                              "div",
                              { staticStyle: { "padding-top": "5px" } },
                              [_vm._v("扫一扫，下载ios端")]
                            ),
                            _vm._v(" "),
                            _c("img", {
                              staticStyle: { width: "25px", height: "25px" },
                              attrs: {
                                src: require("../assets/appdownicon/iosapp.png")
                              }
                            })
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "androidapp" }, [
                          _c("img", {
                            staticClass: "ioscode",
                            attrs: { src: _vm.androidappcode }
                          }),
                          _vm._v(" "),
                          _c("div", { staticClass: "iostitle" }, [
                            _c(
                              "div",
                              { staticStyle: { "padding-top": "5px" } },
                              [_vm._v("扫一扫，下载安卓端")]
                            ),
                            _vm._v(" "),
                            _c("img", {
                              staticStyle: { width: "25px", height: "25px" },
                              attrs: {
                                src: require("../assets/appdownicon/androidapp.png")
                              }
                            })
                          ])
                        ])
                      ])
                    ]
                  )
                ])
              ],
              1
            ),
            _vm._v(" "),
            _c("li")
          ])
        ])
      ]),
      _vm._v(" "),
      _vm.isShowNavCenter
        ? _c(
            "div",
            { staticStyle: { "background-color": "#fff", width: "100%" } },
            [
              _c(
                "div",
                {
                  staticClass: "w w1200",
                  staticStyle: { "background-color": "#fff" }
                },
                [
                  _c(
                    "el-row",
                    {
                      staticClass: "logotop",
                      attrs: { type: "flex", justify: "center", align: "top" }
                    },
                    [
                      _c("el-col", { attrs: { span: 6 } }, [
                        _c(
                          "div",
                          { staticClass: "fl" },
                          [
                            _c(
                              "el-image",
                              {
                                staticClass: "logo",
                                staticStyle: { cursor: "pointer" },
                                attrs: { src: _vm.homelogo, fit: "fill" },
                                on: {
                                  click: function($event) {
                                    return _vm.$router.push("/")
                                  }
                                }
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "image-slot",
                                    attrs: { slot: "error" },
                                    slot: "error"
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "el-icon-picture-outline"
                                    })
                                  ]
                                )
                              ]
                            )
                          ],
                          1
                        )
                      ]),
                      _vm._v(" "),
                      _c("el-col", { attrs: { span: 11 } }, [
                        _c("div", { staticClass: "grid-content bg-purple" }, [
                          _c(
                            "div",
                            { staticClass: "div-width" },
                            [
                              _c(
                                "el-dropdown",
                                { on: { command: _vm.handleCommand1 } },
                                [
                                  _c(
                                    "span",
                                    { staticClass: "el-dropdown-link" },
                                    [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(_vm.name)
                                      ),
                                      _c("i", {
                                        staticClass:
                                          "el-icon-arrow-down el-icon--right"
                                      })
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "el-dropdown-menu",
                                    {
                                      attrs: { slot: "dropdown" },
                                      slot: "dropdown"
                                    },
                                    [
                                      _c(
                                        "el-dropdown-item",
                                        { attrs: { command: "商品" } },
                                        [_vm._v("商品")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "el-dropdown-item",
                                        { attrs: { command: "编码" } },
                                        [_vm._v("编码")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "el-dropdown-item",
                                        { attrs: { command: "店铺" } },
                                        [_vm._v("店铺")]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("el-input", {
                                staticClass: "input-width",
                                attrs: { placeholder: _vm.hotSearchList[0] },
                                nativeOn: {
                                  keyup: function($event) {
                                    if (
                                      !$event.type.indexOf("key") &&
                                      _vm._k(
                                        $event.keyCode,
                                        "enter",
                                        13,
                                        $event.key,
                                        "Enter"
                                      )
                                    ) {
                                      return null
                                    }
                                    return _vm.getSearchClick("")
                                  }
                                },
                                model: {
                                  value: _vm.searchInput,
                                  callback: function($$v) {
                                    _vm.searchInput = $$v
                                  },
                                  expression: "searchInput"
                                }
                              }),
                              _vm._v(" "),
                              _c("el-image", {
                                staticStyle: {
                                  width: "20px",
                                  "margin-right": "12px",
                                  "margin-bottom": "-3px"
                                },
                                attrs: {
                                  src:
                                    _vm.$imageUrl +
                                    "/icon_camera1778468257403.png"
                                },
                                on: {
                                  click: function($event) {
                                    _vm.showImage = true
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c(
                                "el-button",
                                {
                                  staticClass: "button-style",
                                  attrs: { slot: "append" },
                                  on: {
                                    click: function($event) {
                                      return _vm.getSearchClick("")
                                    }
                                  },
                                  slot: "append"
                                },
                                [_vm._v("搜索")]
                              )
                            ],
                            1
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticStyle: {
                              "margin-top": "5px",
                              "text-align": "left"
                            }
                          },
                          _vm._l(_vm.hotSearchList, function(item, index) {
                            return _c(
                              "span",
                              { key: index },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass: "link",
                                    on: {
                                      click: function($event) {
                                        return _vm.getSearchClick(item)
                                      }
                                    }
                                  },
                                  [_vm._v(_vm._s(item))]
                                ),
                                _vm._v(" "),
                                _vm.hotSearchList.length - index != 1
                                  ? _c("el-divider", {
                                      attrs: { direction: "vertical" }
                                    })
                                  : _vm._e()
                              ],
                              1
                            )
                          }),
                          0
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        {
                          staticStyle: { "text-align": "right" },
                          attrs: { span: 7 }
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "grid-content shopgoodsCar" },
                            [
                              _c(
                                "el-button",
                                {
                                  staticClass: "shopgoods",
                                  attrs: { slot: "reference" },
                                  on: {
                                    click: function($event) {
                                      return _vm.remind(0)
                                    }
                                  },
                                  slot: "reference"
                                },
                                [
                                  _c("el-image", {
                                    staticStyle: {
                                      width: "20px",
                                      "margin-right": "5px",
                                      "margin-bottom": "-3px"
                                    },
                                    attrs: {
                                      src:
                                        _vm.$imageUrl +
                                        "/pcImages/images/shopCardIcon1.png"
                                    }
                                  }),
                                  _vm._v("  购物车\n               "),
                                  _vm.list.length > 0
                                    ? _c("span", [
                                        _vm._v(_vm._s(_vm.list.length))
                                      ])
                                    : _vm._e()
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "el-button",
                                {
                                  staticClass: "shopgoods",
                                  attrs: { slot: "reference" },
                                  on: {
                                    click: function($event) {
                                      return _vm.remind(2)
                                    }
                                  },
                                  slot: "reference"
                                },
                                [
                                  _c("el-image", {
                                    staticStyle: {
                                      width: "20px",
                                      "margin-right": "5px",
                                      "margin-bottom": "-3px"
                                    },
                                    attrs: {
                                      src:
                                        _vm.$imageUrlNew +
                                        "/20250425-1043441745549061872.png"
                                    }
                                  }),
                                  _vm._v("\n            批量下单\n            ")
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticStyle: { "background-color": "#fff", width: "100%" } },
        [
          _vm.isShowNav
            ? _c("div", { staticClass: "w w1200" }, [
                _c("div", { staticClass: "categorys" }, [
                  _c(
                    "div",
                    {
                      staticClass: "categorys-type",
                      on: {
                        mouseenter: _vm.mouseenterBox,
                        mouseleave: _vm.mouseLeaveBox
                      }
                    },
                    [_vm._m(0)]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowCategoryList,
                          expression: "isShowCategoryList"
                        }
                      ],
                      staticClass: "categorys-tab-content",
                      on: { mouseleave: _vm.mouseLeaveBox }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "categorys-items",
                          attrs: { id: "cata-nav" }
                        },
                        _vm._l(_vm.categoryList, function(oneItem, index) {
                          return _c(
                            "div",
                            {
                              key: index + "_item",
                              staticClass: "categorys-item"
                            },
                            [
                              _c("div", { staticClass: "item item-content" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass: "categorys-title",
                                    staticStyle: {
                                      display: "flex",
                                      "justify-content": "space-between"
                                    }
                                  },
                                  [
                                    _c("strong", [
                                      _c(
                                        "span",
                                        { staticClass: "oneClassfiy" },
                                        [_vm._v(_vm._s(oneItem.name))]
                                      )
                                    ])
                                  ]
                                ),
                                _vm._v(" "),
                                _c("i", { staticClass: "iconfont icon-ele" }, [
                                  _c("img", {
                                    staticStyle: {
                                      "vertical-align": "baseline"
                                    },
                                    attrs: {
                                      src:
                                        _vm.$imageUrl +
                                        "/pcImages/images/icon/Arrow.png"
                                    }
                                  })
                                ])
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "categorys-items-layer" },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "cate-layer-con clearfix" },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "cate-layer-left" },
                                        _vm._l(_vm.sub[index], function(
                                          subItem,
                                          index1
                                        ) {
                                          return _c(
                                            "div",
                                            {
                                              key: index1 + "sunItem",
                                              staticClass: "cate_channel"
                                            },
                                            [
                                              _c(
                                                "span",
                                                { staticClass: "fenlei" },
                                                [
                                                  _vm._v(
                                                    _vm._s(subItem.name) + " "
                                                  ),
                                                  _c("i", {
                                                    staticClass:
                                                      "el-icon-arrow-right",
                                                    staticStyle: {
                                                      "font-weight": "bold"
                                                    }
                                                  })
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "cete-details-one"
                                                },
                                                _vm._l(subItem.sub, function(
                                                  itemchildren,
                                                  indexchildren
                                                ) {
                                                  return _c(
                                                    "span",
                                                    {
                                                      key:
                                                        indexchildren +
                                                        "childrenItem",
                                                      staticClass:
                                                        "catedetails",
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          return _vm.routeToGoodsList(
                                                            itemchildren,
                                                            4,
                                                            itemchildren
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          itemchildren.name
                                                        )
                                                      )
                                                    ]
                                                  )
                                                }),
                                                0
                                              )
                                            ]
                                          )
                                        }),
                                        0
                                      ),
                                      _vm._v(" "),
                                      (oneItem.length == 0
                                      ? true
                                      : false)
                                        ? _c(
                                            "div",
                                            { staticClass: "nodataCss" },
                                            [
                                              _c("p", [
                                                _vm._v("暂无相关分类数据")
                                              ])
                                            ]
                                          )
                                        : _vm._e()
                                    ]
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c("div", { staticClass: "clear" })
                            ]
                          )
                        }),
                        0
                      )
                    ]
                  )
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "nav-main" },
                  [
                    _c(
                      "el-menu",
                      {
                        staticClass: "el-menu-demo",
                        attrs: {
                          "default-active": _vm.$route.path,
                          mode: "horizontal",
                          router: ""
                        },
                        on: { select: _vm.handleSelect }
                      },
                      [
                        _vm._l(_vm.navList, function(item, index) {
                          return [
                            _c(
                              "el-menu-item",
                              {
                                key: index + "_nav",
                                attrs: { index: item.navUrl }
                              },
                              [
                                _c("i", [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(item.navTitle) +
                                      "\n              "
                                  )
                                ])
                              ]
                            )
                          ]
                        })
                      ],
                      2
                    )
                  ],
                  1
                )
              ])
            : _vm._e()
        ]
      ),
      _vm._v(" "),
      _vm.showImage
        ? _c("searchImgUploadDialog", { on: { closeDialog: _vm.closeDialog } })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("a", { attrs: { href: "javascript:;" } }, [
      _c("i", { staticClass: "el-icon-menu" }),
      _vm._v(" 全部商品分类")
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-49be2ebe", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-49be2ebe","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/topnav.vue
// module id = dR1n
// module chunks = 129